__turbopack_context__.v({
  "cart": "cart-module__HbxmVG__cart",
  "divider": "cart-module__HbxmVG__divider",
  "footer": "cart-module__HbxmVG__footer",
  "footerItem": "cart-module__HbxmVG__footerItem",
  "footerSection": "cart-module__HbxmVG__footerSection",
  "header": "cart-module__HbxmVG__header",
  "isMobile": "cart-module__HbxmVG__isMobile",
  "m": "cart-module__HbxmVG__m",
  "main": "cart-module__HbxmVG__main",
  "s": "cart-module__HbxmVG__s",
});
